export default function ChatgptEmail() {
  return <h2>Chatgpt Email</h2>;
}
